import { defineAsyncComponent } from 'vue'
export default {
  classes: defineAsyncComponent(() => import("/vercel/path0/layouts/classes.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/vercel/path0/layouts/guest.vue").then(m => m.default || m))
}